// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3337da201425144be1fe8737d5102f104f5176c8.chunk.js";
};